export default {
  ENERGY_INTERVAL_EXPORT: 'M_E_INT_EXP',
  ENERGY_INTERVAL_IMPORT: 'M_E_INT_IMP',
  ENERGY_INTERVAL: 'E_INT',
};
